import React, { Component } from 'react';
import _ from 'lodash';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
  UncontrolledTooltip
} from 'reactstrap';
import { CirclePicker } from 'react-color';
import BootstrapTable2 from 'react-bootstrap-table-next';
import filterFactory, { textFilter, selectFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';
import moment from 'moment';
import Service from './services';
import Loader from '../../../commons/loader';
import { PaginationTotal, DatetimePicker } from '../../../commons/controls';
import NetworkEmptyState from '../../../commons/networkemptystate';
import DataEmptyState from '../../../commons/dataemptystate';
import Utility from './Utility';
import CustomTooltip from '../../../components/Tooltip/CustomTooltip';
import getTooltip from './NaptarTooltips';
import RFForm from '../../../components/Form/RFForm';
import RFField from '../../../components/Form/RFField';
import SelectField from '../../../components/Form/SelectField';
import TimeFormatter from '../../../commons/TimeFormatter';
import Lib from '../../../commons/lib';

class EsemenyTipusConent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      insert: true,
      kezdete: '',
      napkezdetora: '',
      aktiv: true,
      vege: '',
      modalEsemenytipus: false,
      modalEsemenytipusTorles: false,
      esemenytipusok: [],
      esemenytipusModositObj: {},
      idotartam: '',
      szinkod: '',
      // ['LOAD', 'DATA', 'NETW', 'TABL']
      tableStatus: 'LOAD',
      naptartipus: null,
      naptartipusok: []
    };

    this.options = {
      sizePerPage: 5,
      showTotal: true,
      paginationTotalRenderer: PaginationTotal,
      sizePerPageList: [
        { text: '5', value: 5 },
        { text: '10', value: 10 },
        { text: '25', value: 25 }
      ]
    };
  }

  componentDidMount() {
    this.updateTable();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.activeTab !== '2' && this.props.activeTab === '2') {
      this.updateTable();
    }
  }

  hasRoleKarb = () => {
    return this.props.globals.hasRole(['NAPTAR_NAPTAR_ESEMENY_TIPUS'], true);
  }

  listNaptartipus = () => {
    Service.listNaptartipus(true, (err, res) => {
      if (!err) {
        this.setState({ naptartipusok: res[0] });
      }
    });
  }

  updateTable = () => {
    this.setState({ tableStatus: 'LOAD' }, () => {
      Service.listEsemenytipus((err, res) => {
        if (!err) {
          let status = res[0].length == 0 ? 'DATA' : 'TABL';
          this.setState({ esemenytipusok: res[0], tableStatus: status });
        } else {
          this.setState({ tableStatus: 'NETW' });
        }
      });
    });
  }

  toggleEsemenytipus = () => {
    this.setState((prevState) => { return ({ modalEsemenytipus: !prevState.modalEsemenytipus }); });
  }

  toggleEsemenytipusView = () => {
    this.setState((prevState) => { return ({ modalEsemenytipusView: !prevState.modalEsemenytipusView }) });
  }

  toggleEsemenytipusTorles = () => {
    this.setState((prevState) => { return ({ modalEsemenytipusTorles: !prevState.modalEsemenytipusTorles }); });
  }

  handleEsemenytipusAddClick = () => {
    this.listNaptartipus();
    this.setState({ insert: true, esemenytipusModositObj: { aktiv: true }, naptartipus: null, szinkod: '', kezdete: null, vege: null, idotartam: null });
    this.toggleEsemenytipus();
  }

  handleEsemenytipusViewClick = (id) => {
    this.setState((prevState) => {
      const esemenytipus = prevState.esemenytipusok.find(element => element.id === id);
      return ({ esemenytipusModositObj: esemenytipus });
    });
    this.toggleEsemenytipusView();
  }

  handleEsemenytipusEditClick = (id) => {
    this.listNaptartipus();
    this.setState((prevState) => {
      const esemenytipus = prevState.esemenytipusok.find(element => element.id === id);
      return ({
        esemenytipusModositObj: esemenytipus,
        insert: false,
        naptartipus: { id: esemenytipus.naptartipusid, nev: esemenytipus.naptartipusnev },
        szinkod: esemenytipus.szinkod,
        kezdete: esemenytipus.kezdete && new Date(esemenytipus.kezdete),
        vege: esemenytipus.vege && new Date(esemenytipus.vege),
        idotartam: esemenytipus.idotartam
      });
    });
    this.toggleEsemenytipus();
  }

  handleEsemenytipusDeleteClick = (id) => {
    this._currentDeleteId = id;
    this.toggleEsemenytipusTorles();
  }

  handleDateInputChange = (e, v, name) => {
    const value = v === '' ? null : v;
    this.setState({
      [name]: value
    });
  }

  handleColorChange = (color) => {
    this.setState({ szinkod: color.hex && color.hex.substr(1, 6) });
  }

  checkDate = (name) => {
    let date = this.state[name];
    if (date) {
      if (name) {
        if (name === 'kezdete') {
          date = new Date(this.state.kezdete)
        }
        if (name === 'vege') {
          date = new Date(this.state.vege)
        }
  
        let minutes = date.getMinutes();
        if (minutes.toString().length > 1) {
          let deviation = minutes % 5;
          if (deviation) {
            this.props.globals.addWarning("Az időpont perce csak öttel osztható szám lehet!");
            let correction = deviation <= 2 ? deviation : -(5 - deviation);
            date.setMinutes(minutes - correction);
          }
        } else {
          if (minutes < 3) {
            date.setMinutes(0);
          } else {
            date.setMinutes(5);
          }
        }
        
        if (date.getHours() * 60 + date.getMinutes() <= this.state.napkezdetora * 60 && !(date.getHours() == 0 && date.getMinutes() == 0)) {
          this.props.globals.addError("A naptár záró időpontja nem lehet korábbi, vagy ugyanaz, mint a naptár kezdő órája!");
          date = null;
        }

        this.setState({ [name]: new Date(date) });
    } else {
      this.setState({ [name]: null });
    }}
    
  }

  handleTimeChange = (name, date) => {
    if (date) {
      const d = new Date(date);
      // A kezdete és vege mező el van állítva, majd visszaírva, hogy React re-renderelje a mezőt akkor is, amikor a tárolt érték nem változott a korrigálás után
      // Például ha 13:35-ről 13:36-ra változtat a felhasználó, akkor alapba nem lenne re-render, mert a 13:35-re korrigált érték kerül beírásra,
      // és ez az érték van a változóban eredetileg is, de felületen 13:36 fog látni a felhasználó
      this.setState({ [name]: new Date() }, () => {
        this.setState({ [name]: d });
      });
    } else {
      this.setState({ [name]: null });
    }
  }

  iconFormatter = (cell) => {
    return (
      <div>
        <Button className="icon-eye table-action-icon" id={'action-view-' + cell + 'megtekintes'} onClick={() => this.handleEsemenytipusViewClick(cell)} />
        <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="left" target={'action-view-' + cell + 'megtekintes'} delay={0}>Megtekintés</UncontrolledTooltip>
        {
          this.hasRoleKarb()
            ? (
              <React.Fragment>
                <Button className="icon-pencil table-action-icon" id={'action-view-' + cell + 'modositas'} onClick={() => this.handleEsemenytipusEditClick(cell)} />
                <Button className="icon-trash table-action-icon" id={'action-view-' + cell + 'torles'} onClick={() => this.handleEsemenytipusDeleteClick(cell)} />
                <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="left" target={'action-view-' + cell + 'modositas'} delay={0}>Módosítás</UncontrolledTooltip>
                <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="left" target={'action-view-' + cell + 'torles'} delay={0}>Törlés</UncontrolledTooltip>
              </React.Fragment>
            )
            : <div />
        }


      </div>
    );
  }

  addEsemenytipus = (event, esemenytipusObj) => {
    esemenytipusObj.kezdete = this.state.kezdete && TimeFormatter.formatIso(this.state.kezdete);
    esemenytipusObj.vege = this.state.vege && TimeFormatter.formatIso(this.state.vege);
    esemenytipusObj.szinkod = this.state.szinkod;
    esemenytipusObj.naptartipusid = this.state.naptartipus && this.state.naptartipus.id;
    Service.addEsemenytipus(esemenytipusObj, (err) => {
      if (!err) {
        this.updateTable();
        this.toggleEsemenytipus();
        this.props.globals.addSuccess('Eseménytípus hozzáadva!');
      }
    });
  }

  modifyEsemenytipus = (event, esemenytipusObj) => {
    esemenytipusObj.id = this.state.esemenytipusModositObj.id;
    esemenytipusObj.kezdete = this.state.kezdete && TimeFormatter.formatIso(this.state.kezdete);
    esemenytipusObj.vege = this.state.vege && TimeFormatter.formatIso(this.state.vege);
    esemenytipusObj.szinkod = this.state.szinkod;
    esemenytipusObj.naptartipusid = this.state.naptartipus && this.state.naptartipus.id;
    Service.editEsemenytipus(esemenytipusObj, (err) => {
      if (!err) {
        this.updateTable();
        this.toggleEsemenytipus();
        this.props.globals.addSuccess('Eseménytípus módosítva!');
      }
    });
  }

  deleteEsemenytipus = () => {
    this.toggleEsemenytipusTorles();
    Service.deleteEsemenytipus(this._currentDeleteId, (err) => {
      if (!err) {
        this.updateTable();
        this.props.globals.addSuccess('Eseménytípus törölve!');
      }
    });
  }

  statusFormatter = (cell) => {
    switch (cell) {
      case true:
        return <span className="badge badge-success">Aktív</span>;
      case false:
        return <span className="badge badge-default">Inaktív</span>;
      default:
        return <span className="badge badge-default">Ismeretlen</span>;
    }
  }

  renderTable = () => {
    const selectOptionsAllapot = [
      { value: true, label: 'Aktív' },
      { value: false, label: 'Inaktív' }
    ];

    const columns = [
      {
        dataField: 'nev',
        text: 'Név',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        sort: true
      },
      {
        dataField: 'azonosito',
        text: 'Azonosító',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        sort: true
      },
      {
        dataField: 'szinkod',
        text: 'Szín',
        formatter: () => {},
        style: (szinkod) => { return { backgroundColor: '#' + szinkod } }
      },
      {
        dataField: 'naptartipusnev',
        text: 'Naptártípus',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        sort: true
      },
      {
        dataField: 'aktiv',
        text: 'Állapot',
        filter: selectFilter({
          options: selectOptionsAllapot,
          placeholder: 'Összes',
        }),
        style: {
          textAlign: 'center',
          whiteSpace: 'pre-line'
        },
        formatter: this.statusFormatter,
        sort: true
      },
      {
        dataField: 'id',
        text: 'Műveletek',
        formatter: this.iconFormatter
      }
    ];

    return (
      <BootstrapTable2
        bootstrap4
        keyField="id"
        data={this.state.esemenytipusok}
        columns={columns}
        filter={filterFactory()}
        pagination={paginationFactory(Lib.bootstraptableProps)}
      />
    );
  }

  renderState = () => {
    switch (this.state.tableStatus) {
      case 'NETW':
        return <NetworkEmptyState hasImage submitClick={this.updateTable} />;
      case 'DATA':
        return <DataEmptyState hasImage />;
      case 'TABL':
        return this.renderTable();
      case 'LOAD':
        return <Loader />;
    }
  }

  render() {
    return (
      <div>
        <div className="row">
          {
            this.hasRoleKarb() ?
              (
                <div className="col-sm-12">
                  <Button className="pull-left table-new-button" color="primary" onClick={this.handleEsemenytipusAddClick}>Új eseménytípus</Button>
                </div>
              )
              : <div />
          }
        </div>
        {this.renderState()}
        <Modal isOpen={this.state.modalEsemenytipus} toggle={this.toggleEsemenytipus} className={this.props.className} backdrop="static">
          <RFForm onSubmit={this.state.insert ? this.addEsemenytipus : this.modifyEsemenytipus}>
            <ModalHeader>Eseménytípus {this.state.insert ? "felvétel" : "módosítás"}</ModalHeader>
            <ModalBody>
              <div className="row">
                <div className="col-md-12" style={{ paddingBottom: 10 }}>
                  <SelectField
                    required
                    label='Naptártípus:'
                    name="naptartipus"
                    id="naptartipus"
                    noOptionsMessage={() => 'Nincs keresési eredmény'}
                    loadingMessage={() => 'Keresés...'}
                    onChange={v => this.setState({ naptartipus: v }) }
                    placeholder="Válassz naptártípust..."
                    options={this.state.naptartipusok || []}
                    value={this.state.naptartipus}
                    isDisabled={!this.state.insert}
                    getOptionValue={option => option.id}
                    getOptionLabel={option => option.nev}
                  />
                </div>
                <div className="col-md-12">
                  <div>
                    <RFField
                      label={'Név: *'}
                      name="nev"
                      id="nev"
                      value={this.state.esemenytipusModositObj && this.state.esemenytipusModositObj.nev}
                      required
                    />
                  </div>
                </div>
                <div className="col-md-12">
                  <div>
                    <RFField
                      label={'Azonosító: *'}
                      name="azonosito"
                      id="azonosito"
                      value={this.state.esemenytipusModositObj && this.state.esemenytipusModositObj.azonosito}
                      disabled={!this.state.insert}
                      required
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <RFField
                    type='time'
                    label={<React.Fragment>Kezdete: <CustomTooltip text={getTooltip('kezdete')} id="kezdeteTT" /></React.Fragment>}
                    id="kezdete"
                    name="kezdete"
                    formatDate={'YYYY-MM-DD HH:mm'}
                    value={this.state.kezdete && new Date(this.state.kezdete)}
                    onChange={(d) => { this.handleTimeChange('kezdete', d) }}
                    onBlur={() => this.checkDate('kezdete')}
                  />
                </div>
                <div className="col-md-6">
                  <RFField
                    type='time'
                    label={<React.Fragment>Vége: <CustomTooltip text={getTooltip('vege')} id="vegeTT" /></React.Fragment>}
                    id="vege"
                    name="vege"
                    formatDate={'YYYY-MM-DD HH:mm'}
                    value={this.state.vege && new Date(this.state.vege)}
                    onChange={(d) => { this.handleTimeChange('vege', d) }}
                     onBlur={() => this.checkDate('vege')}
                    disabled={(this.state.esemenytipusModositObj && this.state.esemenytipusModositObj.idotartam) || !this.state.kezdete}
                  />
                </div>
                <div className="col-4">
                  <div>
                    <RFField
                      label={'Időtartam (perc):'}
                      tooltip={<CustomTooltip text={getTooltip('idotartam')} id="idotartamTT" />}
                      name="idotartam"
                      id="idotartam"
                      numberOnlyWhole
                      onChange={(e, v) => this.setState((prevState) => { return { esemenytipusModositObj: { ...prevState.esemenytipusModositObj, idotartam: v } }; })}
                      value={this.state.idotartam}
                      disabled={this.state.vege || !this.state.kezdete}
                    />
                  </div>
                </div>
                <div style={{ paddingLeft: '15px', marginBottom: '10px' }}>
                  <div>
                    <RFField
                      label={'Aktív'}
                      type="checkbox"
                      name="aktiv"
                      id="aktiv"
                      value={this.state.esemenytipusModositObj && this.state.esemenytipusModositObj.aktiv}
                    />
                  </div>
                </div>
                <div className="col-md-12">
                  <div>
                    <RFField
                      label={'Leírás:'}
                      style={{ height: '120px' }}
                      type="textarea"
                      name="megjegyzes"
                      id="megjegyzes"
                      value={this.state.esemenytipusModositObj && this.state.esemenytipusModositObj.megjegyzes}
                    />
                  </div>
                </div>
                <div className="col-md-4" style={{ paddingBottom: 10, paddingTop: 10 }}>
                  Színválasztás: *
                  <CustomTooltip text={getTooltip('szinvalasztas')} id="szinvalasztasTT" />
                </div>
                <div className="w-100" />
                <div className="row">
                  <div className="col-md-8" style={{ paddingLeft: 30 }}>
                    <CirclePicker name="szinkod" id="szinkod" color={this.state.szinkod} onChangeComplete={this.handleColorChange} colors={["#607d8b", "#795548", "#9c27b0", "#baaaff", "#3f51b5", "#2196f3", "#00bcd4", "#009688", "#4caf50", "#8bc34a", "#cddc39", "#16ed75", "#ffeb3b", "#ffc107", "#ff9800", "#ff5722", "#f44336", "#e91e63"]} />
                  </div>
                </div>
              </div>
            </ModalBody>
            <ModalFooter>
              <Button color="primary">Mentés</Button>{' '}
              <Button type="button" color="secondary" onClick={this.toggleEsemenytipus}>Mégsem</Button>
            </ModalFooter>
          </RFForm>
        </Modal>
        <Modal isOpen={this.state.modalEsemenytipusView} toggle={this.toggleEsemenytipusView} className={this.props.className} backdrop="static">
          <ModalHeader>
            Megtekintés
          </ModalHeader>
          <ModalBody>
            <div>
              <h6>Adatok</h6>
              <b>Naptártípus: </b>{this.state.esemenytipusModositObj.naptartipusnev}<br />
              <b>Név: </b>{this.state.esemenytipusModositObj.nev}<br />
              <b>Azonosító: </b>{this.state.esemenytipusModositObj.azonosito}<br />
              <b>Állapot: </b>{this.state.esemenytipusModositObj.aktiv ? 'Aktív' : 'Inaktív'}<br />
              <b>Kezdete: </b>{this.state.esemenytipusModositObj.kezdete && TimeFormatter.format(this.state.esemenytipusModositObj.kezdete, 'HH:mm')}<br />
              <b>Vége: </b>{this.state.esemenytipusModositObj.vege && TimeFormatter.format(this.state.esemenytipusModositObj.vege, 'HH:mm')}<br />
              <b>Időtartam (perc): </b>{this.state.esemenytipusModositObj.idotartam}<br />
              <b>Szín: </b><div style={{ height: 20, width: 20, backgroundColor: '#' + this.state.esemenytipusModositObj.szinkod }}/>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.toggleEsemenytipusView}>Vissza</Button>
          </ModalFooter>
        </Modal>
        <Modal isOpen={this.state.modalEsemenytipusTorles} toggle={this.toggleEsemenytipusTorles} className={this.props.className} backdrop="static">
          <ModalHeader>Törlés</ModalHeader>
          <ModalBody>Biztosan törölni szeretnéd ezt a eseménytípust?</ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.deleteEsemenytipus}>OK</Button>
            <Button type="button" color="secondary" onClick={this.toggleEsemenytipusTorles}>Mégsem</Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

export default EsemenyTipusConent;
